import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-department-spotlight-create',
  templateUrl: './department-spotlight-create.component.html',
  styleUrls: ['./department-spotlight-create.component.scss']
})
export class DepartmentSpotlightCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  submitted = false;
  public Form: FormGroup;
  public news = [];
  public departments = [];
  public years = [];

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      // console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/departmentSpotlightbyid/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.Form.patchValue({
              _id: data.data._id,
              heading: data.data.heading,
              department: data.data.department,
              image: data.data.image,
              description: data.data.description,
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });


    this.http.get<any>(this.api_endpoint+'/courses/').subscribe(
      data => {
        this.departments = data.data;
      
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });

    this.Form = this.formBuilder.group({
      department: ['', Validators.required],
      image: ['', Validators.required],
      description: ['', Validators.required],
      heading: ['', Validators.required],
      _id: ['']
    })
  }

  get f() { return this.Form.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    if(this.action == 'Submit'){
    
    var data = {
      "department" : this.Form.value.department,
      "image" : this.Form.value.image,
      "description" : this.Form.value.description,
      "heading" : this.Form.value.heading,
      "admin" : sessionStorage.getItem('adminName'),
    };
    // console.log(data);
    this.http.post<any>(this.api_endpoint+'/departmentSpotlight', data).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          window.scrollTo(document.documentElement.clientWidth, 0);
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/department-spotlight/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }else{
    var data1 = {
      "department" : this.Form.value.department,
      "image" : this.Form.value.image,
      "description" : this.Form.value.description,
      "heading" : this.Form.value.heading,
      "admin" : sessionStorage.getItem('adminName'),
      "_id" : this.Form.value._id,
    };
      // console.log(data1);     
      this.http.put<any>(this.api_endpoint+'/departmentSpotlight/', data1).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          window.scrollTo(document.documentElement.clientWidth, 0);
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/department-spotlight/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }
  }

}
